import { Departement } from "./departement";

export class Region {
    id: number;
    name: string;
    sigle: string;
    departements: Departement[];
}


